module.exports = __webpack_public_path__ + "img/img59.0be82e08.png";